import React, { useState } from 'react';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { FormSection } from 'components/FormSection';
import { Button, MultipleSelect } from 'components/Inputs';
import { Item, Row } from 'components/Layout';

export const ModalDuplicate = props => {
  const {
    onClose,
    onValidate,
    shopGroups = [],
    otherConfigs = {},
    domainGroupId
  } = props;

  const { themeColors } = useTheme();

  const [{ shopGroupIds }, setState] = useState({ shopGroupIds: [] });

  const [{ shopGroupIdsError }, setError] = React.useState({
    shopGroupIdsError: false
  });

  const toggleError = (key, state) => {
    setError(prevState => ({
      ...prevState,
      [`${key}Error`]: state
    }));
  };

  const handleChange = itemKey => value => {
    const text = typeof value === 'string' ? value.trim() : value;
    toggleError(itemKey, !text);
    setState(prevState => {
      const states = { ...prevState };
      states[itemKey] = text;
      return states;
    });
  };

  const configInOtherGroup = otherConfigs.some(item =>
    shopGroupIds.includes(item.shopGroupId)
  );

  const onNext = async () => {
    let error = false;

    if (!shopGroupIds.length) {
      toggleError('shopGroupIds', true);
      error = true;
    }

    if (!error) {
      await onValidate(
        shopGroupIds.map(id => (id !== domainGroupId ? id : ''))
      );
      onClose();
    }
  };

  return (
    <Modal {...props}>
      <FormSection title="Dupliquer la configuration">
        <Row justify="flex-start">
          <Item xs={6}>
            <MultipleSelect
              title="Vers"
              small
              required
              placeHolder="Selectionnez un ou plusieurs groupement"
              selected={shopGroupIds}
              options={shopGroups}
              onChange={values => {
                handleChange('shopGroupIds')(values.map(el => el.key));
              }}
              error={shopGroupIdsError}
            />
          </Item>
        </Row>
        <Row justify="flex-start">
          <Item xs style={{ minHeight: '70px' }} alignItems="center">
            <Text>
              {configInOtherGroup
                ? 'Une configuration existance sera écrasée suite à la duplication de la configuration actuelle.'
                : ''}
            </Text>
          </Item>
        </Row>
        <Row justify="space-between">
          <Item xs={4}>
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              rounded
              color={themeColors.themeV2.btnGreyBackground}
              fontColor={themeColors.keep_dark}
              onClick={onClose}
            >
              Annuler
            </Button>
          </Item>
          <Item xs={4}>
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              rounded
              onClick={onNext}
            >
              Dupliquer
            </Button>
          </Item>
        </Row>
      </FormSection>
    </Modal>
  );
};

export default ModalDuplicate;
